import { z } from 'zod'

/** Input for requesting a presigned upload (a browser POST policy). */
export const presignUploadInputSchema = z.object({
  fileName: z.string().min(1),
  mimeType: z.string().min(1),
  sizeBytes: z.number().int().min(0),
})
export type PresignUploadInput = z.infer<typeof presignUploadInputSchema>

/**
 * Presigned upload response. `url` + `fields` form an S3 POST policy the
 * browser submits as multipart/form-data; `key` is the object key the file
 * will live at so the caller can reference it afterwards.
 */
export const presignedUploadSchema = z.object({
  url: z.string(),
  fields: z.record(z.string(), z.string()),
  key: z.string(),
})
export type PresignedUpload = z.infer<typeof presignedUploadSchema>

/** Presigned GET response for downloading a private object. */
export const presignDownloadSchema = z.object({
  url: z.string(),
})
export type PresignDownload = z.infer<typeof presignDownloadSchema>
